import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

const MuiCard: Components<Theme>["MuiCard"] = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: ({ theme }) => ({
      position: "relative",
      boxShadow: "none",
      borderRadius: Number(theme.shape.borderRadius) * 2,
      border: `1px solid ${theme.vars.palette.divider}`,
      backgroundColor: "transparent",
      zIndex: 0, // Fix Safari overflow: hidden with border radius
      // Réplica do card real do backoffice (`DashboardMetricCard` da Home) no
      // dark: superfície #121212 (um degrau acima do fundo #0A0A0A), radius 16,
      // borda #262626 (`divider`) e sombra sutil. Hover realça a borda com o
      // laranja primary, como no backoffice. O light mantém o look Minimal.
      ...theme.applyStyles("dark", {
        borderRadius: 16,
        backgroundColor: theme.vars.palette.background.paper,
        boxShadow: "0px 16px 40px -32px rgba(0,0,0,0.45)",
        transition: theme.transitions.create(["border-color", "box-shadow"], {
          duration: 300,
          easing: theme.transitions.easing.easeInOut,
        }),
        "&:hover": {
          borderColor: theme.vars.palette.primary.main,
          boxShadow: "0px 16px 48px -28px rgba(0,0,0,0.60)",
        },
      }),
    }),
  },
};

// ----------------------------------------------------------------------

const MuiCardHeader: Components<Theme>["MuiCardHeader"] = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: {
    titleTypographyProps: { variant: "h6" },
    subheaderTypographyProps: { variant: "body2", marginTop: "4px" },
  },

  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: { root: ({ theme }) => ({ padding: theme.spacing(3, 3, 0) }) },
};

// ----------------------------------------------------------------------

const MuiCardContent: Components<Theme>["MuiCardContent"] = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: { root: ({ theme }) => ({ padding: theme.spacing(3) }) },
};

// ----------------------------------------------------------------------

export const card = { MuiCard, MuiCardHeader, MuiCardContent };
